import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { UpdatePasswordIcon } from "../../assets";
import RoundedButton from "../../shared/components/buttons/RoundedButton";

const PasswordField = ({ isEditing = false, isAgent = false,handleChangeEditor }) => {
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    password: false,
    confirmPassword: false,
  });

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext();

  const handleShowPassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  useEffect(() => {
    if (isEditing) {
      const field = document.getElementById("old-password");
      field?.focus();
    }

    // eslint-disable-next-line
  }, [isEditing]);

  const shouldDisplaySave = () => {
    if (isAgent) {
      if (
        watch("agent.currentPassword") ||
        watch("agent.password") ||
        watch("agent.newPassword")
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        watch("currentPassword") ||
        watch("password") ||
        watch("newPassword")
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div className="grey-bg-wrapper">
      {!isEditing && (
        <div className="d-flex justify-content-between align-items-center">
          <div className="heading">Password</div>
          <div
            className="d-flex align-items-center gap-2 edit-info-button-container"
            onClick={() => {
              handleChangeEditor(true);
            }}
          >
            <img src={UpdatePasswordIcon} alt="" />
            <div className="section-edit-text">Change Password</div>
          </div>
        </div>
      )}
      {isEditing && (
        <>
          <div className="heading sub-heading">Old Password</div>
          <div className={`input-field`}>
            <input
              type={showPassword.currentPassword ? "text" : "password"}
              disabled={!isEditing}
              id="old-password"
              placeholder="Old Password"
              {...register(
                isAgent ? "agent.currentPassword" : "currentPassword"
              )}
            />
            {showPassword.currentPassword ? (
              <IoIosEye
                className="position-absolute end-0 pointer"
                onClick={() => handleShowPassword("currentPassword")}
              />
            ) : (
              <IoIosEyeOff
                className="position-absolute end-0 pointer"
                onClick={() => handleShowPassword("currentPassword")}
              />
            )}
          </div>
          {errors.currentPassword && (
            <div className="error">{errors.currentPassword.message}</div>
          )}
          {errors?.agent?.currentPassword && (
            <div className="error">{errors.agent.currentPassword.message}</div>
          )}
          <div className="heading sub-heading">New Password</div>
          <div className="input-field">
            <input
              type={showPassword.password ? "text" : "password"}
              disabled={!isEditing}
              placeholder="New Password"
              {...register(isAgent ? "agent.password" : "password")}
            />
            <>
              {showPassword.password ? (
                <IoIosEye
                  className="position-absolute end-0 pointer"
                  onClick={() => handleShowPassword("password")}
                />
              ) : (
                <IoIosEyeOff
                  className="position-absolute end-0 pointer"
                  onClick={() => handleShowPassword("password")}
                />
              )}
            </>
          </div>
          {errors.password && (
            <div className="error">{errors.password.message}</div>
          )}
          {errors?.agent?.password && (
            <div className="error">{errors?.agent?.password.message}</div>
          )}
          <div className="heading sub-heading">Confirm Password</div>
          <div className="input-field">
            <input
              type={showPassword.confirmPassword ? "text" : "password"}
              disabled={!isEditing}
              autoFocus={true}
              placeholder="Confirm Password"
              {...register(
                isAgent ? "agent.confirmPassword" : "confirmPassword"
              )}
            />

            {showPassword.confirmPassword ? (
              <IoIosEye
                className="position-absolute end-0 pointer"
                onClick={() => handleShowPassword("confirmPassword")}
              />
            ) : (
              <IoIosEyeOff
                className="position-absolute end-0 pointer"
                onClick={() => handleShowPassword("confirmPassword")}
              />
            )}
          </div>
          {errors.confirmPassword && (
            <div className="error">{errors.confirmPassword.message}</div>
          )}
          {errors?.agent?.confirmPassword && (
            <div className="error">
              {errors?.agent?.confirmPassword.message}
            </div>
          )}
          <div className="mt-4 d-flex justify-content-center gap-3">
            {shouldDisplaySave() && (
              <RoundedButton className="px-4 px-md-5 py-1" type="submit">
                Update
              </RoundedButton>
            )}
            <RoundedButton
              className="px-4 px-md-5 py-1"
              variant="outlined"
              onClick={() => handleChangeEditor(false)}
            >
              Cancel
            </RoundedButton>
          </div>
        </>
      )}
    </div>
  );
};

export default PasswordField;
